module.exports = __webpack_public_path__ + "static/media/pro-ativo.8b064110.svg";